import { styled } from "@mui/material/styles";
import { FiEdit } from "react-icons/fi";

export const EditIcon = styled(FiEdit)(() => ({
  cursor: "pointer",
}));

export const ContentSection = styled("section")(() => ({
  width: "100%",
}));
